<ag-grid-angular
  style="width: 100%; height: 500px;"
  class="ag-theme-alpine"
  [rowData]="rowData"
  [columnDefs]="columnDefs"
  [pagination]="true"
  [defaultColDef]="{ sortable: true, filter: true, resizable: true }">
</ag-grid-angular>
